import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { getOAIBenefitListItem } from "../../Benefits/components/customBenefits/OAI/getOAIBenefitListItem";
import { getPGLIBenefitListItem } from "../../Benefits/components/customBenefits/PGLI/getPGLIBenefitListItem";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const selectorPlanNameByPlanType = (planType: IPlanType): string => {
  const names: Record<IPlanType, string> = {
    WingspanOccupationalAccidentInsurance: getOAIBenefitListItem().name,
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance:
      getPGLIBenefitListItem().name,
    MeridioHealth: "Meridio Health"
  };

  return names[planType] || "Insurance plan";
};
